import { render, staticRenderFns } from "./ProductCardSelfscanning.vue?vue&type=template&id=1b86015a"
import script from "./ProductCardSelfscanning.vue?vue&type=script&lang=js"
export * from "./ProductCardSelfscanning.vue?vue&type=script&lang=js"
import style0 from "./ProductCardSelfscanning.vue?vue&type=style&index=0&id=1b86015a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports